'use client';

import { useEffect } from 'react';

let lockCount = 0;
let originalOverflow = '';

function lock() {
  if (lockCount === 0) {
    originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  lockCount++;
}

function unlock() {
  lockCount--;
  if (lockCount === 0) {
    document.body.style.overflow = originalOverflow;
  }
}

/**
 * Centralized body scroll lock with reference counting.
 * Multiple overlapping modals/sheets can safely lock/unlock
 * without interfering with each other.
 */
export function useScrollLock(isActive: boolean) {
  useEffect(() => {
    if (!isActive) return;
    lock();
    return () => unlock();
  }, [isActive]);
}
